import { toast } from "react-toastify";
import { apiURL } from "../utlis/config";
import store from "store";
import $ from "jquery";
// const apiURL = "http://172.105.35.119:8080/api";
var Actions = {
  ///trainee/notification
  addStaffMemberInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/staffMember";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "POST",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  updateStaffMemberInfo: (info) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/staffMember";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: info,
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  // fetchMembersInfo: () => {
  //   return new Promise((resolve, reject) => {
  //     var url = apiURL + "/members";
  //     var settings = {
  //       async: true,
  //       crossDomain: true,
  //       url: url,
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + store.get("authToken")
  //         // fngprt: m.cookie.get("fngprt")
  //       },
  //       data: { domain: "all" },
  //       success: function (response) {
  //         if (response.error) {
  //           toast.error(response.memberMessage);
  //         } else {
  //           toast.info(response.memberMessage)
  //         }
  //         resolve(response);
  //       },
  //       error: function (error) {
  //         if (error.status == 401) {
  //           // message.error("Your session has been expired. Please relogin.");
  //           localStorage.clear();
  //           window.location.reload();
  //         } else if (error.statusText === "abort") {
  //         } else {
  //           // message.error("Some error has occurred.");
  //         }
  //       }
  //     };
  //     $.ajax(settings).done();
  //   });
  // },
  fetchStaffMembersInfo: (
    staffMembeId,
    staffMemberStatus,
    page,
    pageSize,
    searchText,
    startDate,
    endDate
  ) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/staffMember";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: {
          staffMembeId: staffMembeId,
          staffMemberStatus: staffMemberStatus,
          limit: pageSize,
          page: page,
          searchText: searchText !== "" ? searchText : undefined,
          startDate:
            startDate !== "" && startDate !== "Invalid date"
              ? startDate
              : undefined,
          endDate:
            endDate !== "" && endDate !== "Invalid date" ? endDate : undefined,
        },
        success: function (response) {
          if (!response.error) {
            if (searchText === "") {
              toast.info(
                response.memberMessage,
                {
                  position: toast.POSITION.TOP_CENTER,
                },
                { autoClose: 500 }
              );
            }
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };
      $.ajax(settings).done();
    });
  },

  onStaffMembeReady: (staffMemberId, publicStatus) => {
    toast.dismiss();
    return new Promise((resolve, reject) => {
      var url = apiURL + "/staffMember/" + staffMemberId + "/active";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "PUT",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { active: publicStatus },
        success: function (response) {
          // response = JSON.parse(response);
          if (response.error) {
            toast.error(response.memberMessage);
          } else {
            if (publicStatus) {
              toast.info("Staff member activated successfully");
            } else {
              toast.info("Staff member deactivated successfully");
            }
            // toast.info(response.memberMessage);
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            // message.error("Your session has been expired. Please relogin.");
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            // message.error("Some error has occurred.");
          }
        },
      };
      $.ajax(settings).done();
    });
  },
  deactivateStaffMemberId: (staffMemberId) => {
    //deactivateMemberId
    return new Promise((resolve, reject) => {
      var url = apiURL + "/members";
      var settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.get("authToken"),
          // fngprt: m.cookie.get("fngprt")
        },
        data: { staffMemberId },

        success: function (response) {
          if (!response.error) {
            toast.info(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          } else {
            toast.error(
              response.memberMessage,
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
          resolve(response);
        },
        error: function (error) {
          if (error.status == 401) {
            toast.error(
              "Your session has been expired. Please relogin.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
            localStorage.clear();
            window.location.reload();
          } else if (error.statusText === "abort") {
          } else {
            toast.error(
              "Some error has occurred.",
              {
                position: toast.POSITION.TOP_CENTER,
              },
              { autoClose: 500 }
            );
          }
        },
      };

      $.ajax(settings).done();
    });
  },
};
$.ajaxQ = (function () {
  //console.log("--------------------------");
  var id = 0,
    Q = {};
  $(document).ajaxSend(function (e, jqx) {
    jqx._id = ++id;
    Q[jqx._id] = jqx;
  });
  $(document).ajaxComplete(function (e, jqx) {
    delete Q[jqx._id];
  });
  return {
    abortAll: function () {
      var r = [];
      $.each(Q, function (i, jqx) {
        r.push(jqx._id);
        jqx.abort();
      });
      return r;
    },
  };
})();
export default Actions;
